module.exports = __webpack_public_path__ + "assets/img/14_947.4b6f313b.jpg";